<script>
  import { createNamespacedHelpers } from 'vuex';
  import InputText from './InputText';

  const { mapGetters } = createNamespacedHelpers('plate');

  export default {
    name: 'InputLayout',
    components: { InputText },
    props: {
      /** Number of lines of text the base product can include */
      lines: {
        type: [Number, String],
        required: true,
      },
      /** The horizontal space on the base product */
      space: {
        type: [Number, String],
        required: true,
      }
    },
    data() {
      return {
        inputKeys: [
          {
            lineOfText: 1,
            key: 0
          },
          {
            lineOfText: 2,
            key: 0
          },
          {
            lineOfText: 3,
            key: 0
          }
        ]
      }
    },
    computed: {
      ...mapGetters([
        'getSelectedLetterStyle',
        'getSelectedVariant'
      ]),
    },
  };
</script>

<template>
  <div class="letter-edit">
    <div class="letter-edit__text">
      <label>Enter Your 3D Text</label>
      <div class="space-y">
        <InputText
          v-for="index in parseInt(lines)"
          :key="index"
          :variant="getSelectedVariant"
          :letterStyle="getSelectedLetterStyle"
          :lineOfText="parseInt(index)"
          :space="parseFloat(space)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .space-y > * {
    margin-top: 5px;
  }
  .space-y > *:first-child {
    margin-top: 0;
  }
</style>
